import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';


const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  // const [isSearchOpen] = useState(false);


  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };


  return (
    // <header className={`header ${scrolling ? 'sticky-header' : ''}`}>
    <header className>
      {/* Header Top */}
      <div className="header-top bg-dark">
        <div className="container">
          <div className="row justify-content-center justify-content-xl-between align-items-center">
            <div className="col-auto">
              <div className="header-top-contact">
                <ul className='anchor d-md-flex '>
                  <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+919075462128 fw-bold">
                      <i className="fas fa-phone-volume  darkcolor"></i> +91 9075462128
                    </a>
                  </li>
                 <li className='px-md-5 fw-bold'>
                    <a className='text-white' href="tel:+918452916550 fw-bold">
                      <i className="fas fa-phone-volume  darkcolor"></i> +91 8452916550
                    </a>
                  </li>
                  <li>
                    <a className='text-white' href="mailto:booking@meghanacabs.com">
                      <i className="far fa-envelope darkcolor "></i>
                      <span className='text-white fw-bold emailfont'> booking@meghanacabs.com</span>
                    </a>
                  </li>

                          <div class="px-md-5">
    
					             <ul className="socials-2">
  <li><a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><i className="fab fa-facebook-square"></i></a></li>
  <li><a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><i className="fab fa-instagram"></i></a></li>
  <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><i className="fab fa-twitter"></i></a></li>
  <li><a href="https://www.linkedin.com/in" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a></li>
</ul>


				                  </div> 
                </ul>
                
                
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <img src="/images/logo.jpg" className='logoo' alt="logo" />
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolor"></i> {/* Mobile Menu Icon */}
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/faqs" className='fw-bold nav-item'>Faqs</NavDropdown.Item>
                  <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                </NavDropdown>
                  <NavDropdown title="Services" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/services" className='fw-bold nav-item'>Services</NavDropdown.Item>
                  <NavDropdown.Item href="/Pune-To-Mumbai-Cabs" className='fw-bold nav-item'>Pune to Mumbai Cabs</NavDropdown.Item>
                
                </NavDropdown>
                <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
                <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>
                <Nav.Link href="/booking" className='fw-bold nav-item'>Online Booking</Nav.Link>
                <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
                <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
                  <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
                </NavDropdown>
                {/* <Nav.Link href="/blog" className='fw-bold nav-item'>Blog</Nav.Link> */}
              </Nav>
            
            </Navbar.Collapse>
            
          </Container>
         
        </Navbar>
      </div>

   
    </header>
  );
};

export default Header;






